import React, { useEffect } from 'react';
import { View, Image } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

import styles from '../styles';
import { AppText } from '../../../components/form';
import splash_01 from '../../../assets/images/splash_01.jpg';
import logo_purple from '../../../assets/images/logo_purple.png';

const WelcomeOne = ({ navigation }) => {
  useEffect(() => {
    AsyncStorage.getItem('welcomeVisited').then((resp) => {
      if (JSON.parse(resp)) {
        navigation.navigate('Login', { screen: 'Base' });
        // navigation.navigate('Company Plans', { screen: 'Como Funciona: Online' });
        // navigation.navigate('Profile Trainer', { screen: 'Selecione as datas' });
      }
    });
  }, []);
  const navigateTo = (site) => navigation.navigate(`Welcome ${site}`);
  return (
    <View style={styles.viewBase} onTouchEnd={() => navigateTo('Two')}>
      <View style={styles.viewLogo}>
        <Image style={styles.imageLogo} source={logo_purple} />
      </View>
      <View style={styles.lineBlue}>
        <View style={styles.lineCyan}>
          <Image style={styles.imageSplash} source={splash_01} />
        </View>
      </View>
      <View style={styles.card}>
        <AppText style={styles.textWelcome}>{'SEJA\nBEM-VINDO!'}</AppText>
        <View style={styles.viewBallContainer}>
          <View style={[styles.viewBall, styles.viewBallOrange]} />
          <View style={styles.viewBall} />
          <View
            style={styles.viewBall}
          />
        </View>
      </View>
    </View>
  );
};

export default WelcomeOne;
